import React from "react";
import PurpleLine from "images/kosmofi/kosmofi-line.svg";

const PageBreak = ({ belowMd }) => {
  return (
    <div className="py-10 flex flex-col text-center justify-center items-center bg-white text-black">
      <h2 className="font-bold text-center leading-tight px-10 md:px-0" style={{ letterSpacing: -0.25, maxWidth: 577, fontSize: belowMd ? 24 : 36 }}>
        Opens opportunities for every business owner to achieve more
      </h2>
      <img src={PurpleLine} alt="" className="mt-2" style={{ width: 198, height: "auto" }} />
    </div>
  );
};

export default PageBreak;